import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://coqhqbucfsgrbvlncafm.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNvcWhxYnVjZnNncmJ2bG5jYWZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI4MDYwOTMsImV4cCI6MjA0ODM4MjA5M30.6vmmbX01R5AEcNQxYIG7B_xQZEYRcV2DVWcgD7Y3TVs";
export const supabase = createClient(supabaseUrl, supabaseKey);